// frontend/src/admin/AdminContentFullView.js
import React, { useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://80.225.197.31:8001';

const TYPE_ICONS = {
    article: '📰', text: '📝', image: '🖼️', video: '▶️',
    image_carousel: '🖼️🖼️', video_carousel: '▶️▶️',
    table: '📊', numerical: '🔢', flowchart: '📐', html: '🖥️'
};

const CONTAINER_ICONS = { subtopic: '📂', chunk: '📁', micro_chunk: '📄' };

const AdminContentFullView = ({ topicId, onClose }) => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            try {
                const res = await fetch(`${API_BASE}/content-page/topic/${topicId}/flattened`);
                if (!res.ok) throw new Error('Failed to load full view');
                const data = await res.json();
                setItems(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [topicId]);

    return (
        <div className="acfv-overlay">
            <div className="acfv-panel">
                <div className="acfv-header">
                    <h3>Full Content View</h3>
                    <button onClick={onClose}>✕ Close</button>
                </div>

                {error && <div className="ace-error">{error}</div>}

                {loading ? (
                    <p>Loading...</p>
                ) : (
                    <div className="acfv-list">
                        {items.map((item, idx) => (
                            <div
                                key={idx}
                                className="acfv-row"
                                style={{ paddingLeft: `${item.depth * 18}px` }}
                            >
                                <span className="acfv-text">{(item.heading || '(no heading)').substring(0, 100)}</span>
                                <span className="acfv-label">
                                    {item.card_type === 'block' ? item.block_type : item.card_type.replace('_', ' ')}
                                </span>
                                <span className="acfv-icon">
                                    {item.card_type === 'block' ? (TYPE_ICONS[item.block_type] || '📄') : CONTAINER_ICONS[item.card_type]}
                                </span>
                            </div>
                        ))}
                        {items.length === 0 && <p className="ace-empty">No content added yet.</p>}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdminContentFullView;